// extracted by mini-css-extract-plugin
module.exports = {"price_tag_wrapper":"PriceTag_price_tag_wrapper__2waJs","price_vat":"PriceTag_price_vat__363zw"};